import Upload from "components/shared/Upload";
import UploadVideoCM from "components/shared/Video/Upload";
import React from "react";
import { validateFile, validateImg } from "validations";

export default function UploadCm({
  state,
  setState,
  title,
  type = "img",
  id,
  handleDeleteReq,
}) {
  const handleChangeImage = (val) => {
    const isValid = validateImg(val);
    isValid
      ? setState({ url: val, isChanged: true, isWeb: false })
      : setState({ url: null, isChanged: false, isWeb: false });
  };
  const handleChangeVideo = (val) => {
    const isValid = validateFile({
      file: val,
      limit: 20,
      title: "ویدئو",
      file_formats: ["mkv", "mp4", "ogg", "webm", "avi", "mov"],
    });
    isValid
      ? setState({ url: val, isChanged: true, isWeb: false })
      : setState({ url: null, isChanged: false, isWeb: false });
  };

  const handleDelete = () => {
    handleDeleteReq && handleDeleteReq();
    setState({ url: null, isChanged: false, isWeb: false });
  };

  return (
    <>
      {type === "img" ? (
        state.url ? (
          <Upload
            id={id}
            title={title}
            isWeb={state.isWeb}
            isLocal={!state.isWeb}
            file={state.url}
            refillable
            type="add-image"
            onChange={handleChangeImage}
            width={"100%"}
            height={"100%"}
            objectFit="contain"
            onDelete={handleDelete}
          />
        ) : (
          <Upload
            id={id}
            title={title}
            isLocal={state.isChanged}
            file={state.url}
            refillable
            type="add-image"
            onChange={handleChangeImage}
            width={"100%"}
            height={"100%"}
            objectFit="contain"
            onDelete={handleDelete}
          />
        )
      ) : state.url ? (
        <UploadVideoCM
          id={id}
          title={title}
          isWeb={state.isWeb}
          isLocal={!state.isWeb}
          file={state.url}
          refillable
          type="add-video"
          onChange={handleChangeVideo}
          width={"100%"}
          height={"100%"}
          objectFit="contain"
          onDelete={handleDelete}
        />
      ) : (
        <UploadVideoCM
          id={id}
          title={title}
          isLocal={state.isChanged}
          file={state.url}
          refillable
          type="add-video"
          onChange={handleChangeVideo}
          width={"100%"}
          height={"100%"}
          objectFit="contain"
          onDelete={handleDelete}
        />
      )}
    </>
  );
}
